import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getSetting, setSetting } from '../../../../../utils/settings';

const HideChordsPlugin = ({ hideChords, setHideChords }) => {
  const { t } = useTranslation();
  const settingKey = 'hide-chords-plugin/hide-chords';

  function handleHideChords() {
    const hideChordsSetting = getSetting(settingKey);

    // Save setting state to local storage
    if (!hideChordsSetting) {
      setSetting(settingKey, true);
      setHideChords(true);
    } else {
      setSetting(settingKey, false);
      setHideChords(false);
    }
  }

  useLayoutEffect(() => {
    const hideChordsSetting = getSetting(settingKey);
    // Display current plugin state
    if (hideChordsSetting) setHideChords(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- on mount only
  }, []);

  return (
    <div className="song-plugin hide-chords-plugin">
      <span className="plugin__title">{t('view.chords')}</span>
      <div className={`plugin__body ${hideChords ? 'off' : 'on'}`} onClick={handleHideChords}>
        <span className="plugin__toggle">{hideChords ? t('common.off') : t('common.on')}</span>
      </div>
    </div>
  );
};

HideChordsPlugin.propTypes = {
  currentSong: PropTypes.object,
  setCurrentSong: PropTypes.func,
};

export default HideChordsPlugin;
